module.exports = __webpack_public_path__ + "images/emoji/ok.47b462e3e30428821964.png";